module.exports = __webpack_public_path__ + "img/CG.2afd6449.svg";